export default {
  getIsShowFirstElement: state => state.isShowFirstElement || false,
  getSelectRef: state => state.selectRef || null,
};
